import ScrollBooster from 'scrollbooster';
import modalScript from './_modal.js';

export default function () {
  var moreNum = 6;
  $('.items li:nth-child(n + ' + (moreNum + 1) + ')').addClass('is-hidden');
  $('#viewall').on('click', function() {
    $('.items li.is-hidden').slice(0, moreNum).removeClass('is-hidden');
    if ($('.items li.is-hidden').length == 0) {
      $('#viewall').fadeOut();
    }
  });

  function checkBreakPoint() {
    const w = $(window).width();
    if (w <= 767) {
      $('#items').not('.slick-initialized')
      .on("init", function (event, slick) {
        $('#total').append(
          '<span class="all-count"></span>'
        );
        $(".all-count").text(slick.slideCount);
      })
      .slick({
        slidesToShow: 1,
        infinite: false,
        arrows:false,
        dots: true,
        autoplaySpeed: 6000
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        $(".now-count").text(nextSlide + 1);
      });
    } else if( $('#items').hasClass("slick-slider") ) {
      $('#items').slick('unslick');
    }
  }
  $(window).on('resize', checkBreakPoint);
  checkBreakPoint();


  var searchItem = '.filter-item';
  var listItem = '.article';
  var hideClass = 'is-hide';
  var activeClass = 'is-active';

  $(function() {
    $(searchItem).on('click', function() {
      $(searchItem).removeClass(activeClass);
      var item = $(this).addClass(activeClass).data('item');
      search_filter(item);
    });
  });

  /**
   * @param {String} item
   */
  function search_filter(item) {
    $(listItem).removeClass(hideClass);
    if(item === '') {
      return;
    }
    for (var i = 0; i < $(listItem).length; i++) {
      var itemData = $(listItem).eq(i).data('item');
      if(itemData !== item) {
        $(listItem).eq(i).addClass(hideClass);
      }
    }
  }

  const nftIssuedModalBtns = document.querySelectorAll(".issued");
  const nftInProgressModalBtns = document.querySelectorAll(".in-progress");
  const modalBody = document.querySelector('html');
  nftIssuedModalBtns.forEach(function (btn) {
    btn.onclick = function (e) {
      var modal = btn.getAttribute('data-modal');
      document.getElementById(modal).classList.add('active');
      modalBody.classList.add('lock');
      modalScript.open(); //スクロール制御関数
    };
  });
  nftInProgressModalBtns.forEach(function (btn) {
    btn.onclick = function (e) {
      var modal = btn.getAttribute('data-modal');
      document.getElementById(modal).classList.add('active');
      modalBody.classList.add('lock');
      modalScript.open(); //スクロール制御関数
    };
  });
  const closeBtns = document.querySelectorAll(".modal-close");
  closeBtns.forEach(function (btn) {
    btn.onclick = function (e) {
      var modal = btn.closest('.modal');
      modal.classList.remove('active');
      modalBody.classList.remove('lock');
      modalScript.close(); //スクロール制御関数
    };
  });
}
